module.exports = __webpack_public_path__ + "img/YOYOW.c493a515.svg";